var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgVisaIcon = function SvgVisaIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57_10398)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4.47149C0 2.3923 1.68552 0.706787 3.76471 0.706787H28.2353C30.3145 0.706787 32 2.3923 32 4.47149V19.5303C32 21.6095 30.3145 23.295 28.2353 23.295H3.76471C1.68552 23.295 0 21.6095 0 19.5303V4.47149Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.66695 15.6656H7.70528L6.23426 9.88856C6.16444 9.62281 6.01619 9.38788 5.79812 9.27715C5.2539 8.99889 4.65421 8.77743 4 8.66574V8.44333H7.1601C7.59624 8.44333 7.92335 8.77743 7.97787 9.16546L8.74111 13.3327L10.7018 8.44333H12.609L9.66695 15.6656ZM13.6997 15.6656H11.8471L13.3726 8.44333H15.2252L13.6997 15.6656ZM17.6221 10.4441C17.6766 10.0551 18.0037 9.83269 18.3853 9.83269C18.985 9.77685 19.6382 9.88854 20.1834 10.1658L20.5105 8.61084C19.9654 8.38842 19.3657 8.27673 18.8214 8.27673C17.0233 8.27673 15.7149 9.27713 15.7149 10.6656C15.7149 11.7218 16.6417 12.2764 17.2959 12.6105C18.0037 12.9436 18.2763 13.1661 18.2218 13.4992C18.2218 13.9989 17.6766 14.2213 17.1324 14.2213C16.4781 14.2213 15.8239 14.0548 15.2252 13.7765L14.8981 15.3325C15.5523 15.6098 16.2601 15.7215 16.9143 15.7215C18.9305 15.7763 20.1834 14.7769 20.1834 13.2768C20.1834 11.3877 17.6221 11.277 17.6221 10.4441ZM26.6665 15.6656L25.1955 8.44333H23.6155C23.2883 8.44333 22.9612 8.66574 22.8522 8.99889L20.1282 15.6656H22.0354L22.4161 14.6104H24.7594L24.9774 15.6656H26.6665ZM23.8876 10.3883L24.4318 13.1102H22.9063L23.8876 10.3883Z",
    fill: "#172B85"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.20679,
    width: 31,
    height: 21.5882,
    rx: 3.5,
    stroke: "#E1E1E1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_10398"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.706787,
    width: 32,
    height: 22.5882,
    rx: 4,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgVisaIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "visa-icon.6bcf04f0db24d9c1fd8c95226f30e749.svg";